import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { PhotoGalleryAddPhotoComponent } from './PhotoGalleryAddPhoto.component';

@NgModule({
  imports: [
    // Minga dependencies

    // External dependencies
    CommonModule,
  ],
  declarations: [PhotoGalleryAddPhotoComponent],
  exports: [PhotoGalleryAddPhotoComponent],
})
export class PhotoGalleryAddPhotoModule {}
